import { format } from 'date-fns'
import { Chip } from "@mui/material";

export function validateUrl(url) {
  try {
    const parsedUrl = new URL(url)

    if (!['http:', 'https:', 'ftp:'].includes(parsedUrl.protocol)) {
      return false
    }

    const excludedHosts = ['localhost', '127.0.0.1', '::1']
    if (
      excludedHosts.includes(parsedUrl.hostname) ||
      parsedUrl.hostname.startsWith('192.168.') ||
      parsedUrl.hostname.startsWith('10.')
    ) {
      return false
    }

    const tld = parsedUrl.hostname.split('.').pop()
    return tld && tld.length >= 2
  } catch {
    return false
  }
}

// export const convertTimestampToHumanReadable = (timestamp) => {
//   console.log('timestamp', timestamp)
//   const date = new Date(timestamp)
//   return format(date, 'yyyy-MM-dd HH:mm:ss') + ' UTC'
// }

export const disableLink = (record) => {
  console.log('record', record)
  return record.request_sttaus === 'In-Progress' ? null : record.signed_url
}
export const savedTemplatesGridColumns = {
  choice: 'Template Choice',
  template_name: 'Template Name',
  created: 'Created',
}
export const pdfGridColumns = {
  request_timestamp: 'Timestamp',
  campaign: 'Campaign',
  current_contacts: 'Contacts',
  custom_template_name: 'Template',
  request_status: 'Status',
  conditional_url: 'File',
}
export const usageMetricGridColumns = {
  start_date: "Start Date",
  end_date: "End Date",
  quota: "Plan Quota",
  used_quota: "Used Quota",
}

export const usageMetricGridOptionalColumns = {
  usage_metric_id: "Usage Metric ID",
  created_timestamp: "Created",
}


export const campaignGridColumns = {
  campaign_name: 'Campaign',
  total: '#Contacts',
}

export const respondedGridColumns = {
  greeting_name: 'Full Name',
  'ma-addr_line1': 'Street',
}

export const contactVisitsGridColumns = {
  visited: 'visited',
  trackable: 'qrcode-id',
  campaign: 'campaign',
}

export const existingUsersGridColumns = {
  created: "Created",
  name: "Org Name",
  user_name: "User Name",
  email: "Email",
  phone: "Phone",
  account_status: 'Account status',
  confirmation_status: 'Confirmation status',
}

export const usersGridOptionalColumns = {
  customer_id: "Customer ID",
  tpx_id: "Tracking Pixel",
  user_id: "User ID",
  cognito_pool_id: "Cognito Pool ID",
  role: "Role",
}

export const existingPlansGridColumns = {
  name: 'Plan Name',
  description: 'Description',
  monthly_price: 'Monthly Price',
  annual_price: 'Annual Price',
  overage_price: 'Overage Price',
  quota: 'Quota',
}

export const plansGridOptionalColumns = {
  plan_id: 'Plan ID',
  created: 'Created',
  updated: 'Updated'
}


export const existingSubscriptionsGridColumns = {
  user: 'User',
  plan: 'Plan',
  status: 'Status',
  billing_cycle: 'Billing Cycle',
  payment_status: 'Payment Status',
  start_date: 'Start Date',
  end_date: 'End Date',
}

export const subscriptionsGridOptionalColumns = {
  subscription_id: 'Subscription ID',
  customer_id: 'Customer ID',
  subscription_plan_id: 'Subscription Plan ID',
  created_timestamp: 'Created',
  updated_timestamp: 'Updated'
}

export const existingQuotaExtensionsGridColumns = {
  price: "Price",
  quota: "Quota Extensions",
  used_quota: "Used Quota",
  status: "Status",
}

export const quotaExtensionsOptionalColumns = {
  quota_extension_id: "Quota Extension ID",
  created_timestamp: "Created"
}

export const existingActivitiesGridColumns = {
  created: "Created",
  action: "Action"
}
export const existingAdminActivitiesGridColumns = {
  timestamp: "Timestamp",
  actor: "Actor",
  resource_type: "Resource Type",
  resource_id: "Resource ID",
  action: "Action"
}

export const existingPaymentsGridColumns = {
  date: "Date",
  description: "Description",
  amount: "Amount"
}
const DATE_FIELDS = new Set([
  'start_date',
  'end_date',
  'created_timestamp',
  'updated_timestamp',
  'timestamp',
  'created',
  'updated'
]);


export const generateGridColumns = (
  mappingConfig,
  alwaysVisibleColumn,
  margin_top = 0,
  optionalColumns = {}
) => {
  const mainColumns = Object.keys(mappingConfig).map((key) => ({
    field: key,
    headerName: mappingConfig[key],
    flex: 1,
    minWidth: 150,
    hide: false,
    hideable: key !== alwaysVisibleColumn,
    renderCell: (() => {
      if (key === "conditional_url") {
        return (params) => (
          <span>
            {params.value ? (
              <a
                href={params.value}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "#1976d2", fontWeight: 500 }}
              >
                Download
              </a>
            ) : (
              "None"
            )}
          </span>
        );
      }

      if (key === "details") {
        return (params) => {
          if (typeof params.value !== "string") return params.value;
          const parts = params.value.split(" -> ");
          if (parts.length === 2) {
            return (
              <span style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0, width: 'max-content' }}>
                {parts[0]}
                <span style={{ color: '#000', fontWeight: 'bold', fontSize: '1.2em', lineHeight: 1 }}>
                  →
                </span>
                {parts[1]}
              </span>
            );
          }
          return params.value;
        };
      }

      if (key === "quota" || key === "used_quota") {
        return (params) => <div style={{ whiteSpace: "pre-line" }}>{params.value}</div>;
      }

      // ✅ UTC → Local conversion (DISPLAY ONLY)
      if (DATE_FIELDS.has(key)) {
        return (params) => {
          if (!params.value) return "";
          // Use date-only format for start_date and end_date
          if (key === 'start_date' || key === 'end_date') {
            return formatUtcToLocalDateOnly(params.value);
          }
          return formatUtcToLocal(params.value);
        };
      }

      if (key === "status") {
        return (params) => {
          const statusValue = params.value?.toLowerCase() || "unknown";
          const colorMap = {
            active: "success",
            cancelled: "error",
            suspended: "warning",
            "awaiting renewal": "info",
          };
          return (
            <Chip
              label={params.value || "Unknown"}
              color={colorMap[statusValue] || "default"}
              size="small"
              variant="filled"
              sx={{
                fontWeight: 500,
                textTransform: "capitalize",
                marginTop: margin_top ?? 0,
                backgroundColor: statusValue === "draft" || statusValue === "UsedUp" ? "darkgray" : undefined,
                color: statusValue === "draft" ? "white" : undefined
              }}
            />
          );
        };
      }

      if (key === "monthly_price" || key === "annual_price") {
        return (params) => {
          if (params.value === null || params.value === undefined || params.value === "") return "";
          return `$${Number(params.value).toLocaleString()}`;
        };
      }
      if (key === "overage_price") {
        return (params) => {
          if (params.value === null || params.value === undefined || params.value === "") return "";
          return `${Number(params.value).toLocaleString()}c/mailer`;
        };
      }
      return undefined;
    })(),
  }));

  const optionalCols = Object.keys(optionalColumns).map((key) => ({
    field: key,
    headerName: optionalColumns[key],
    flex: 1,
    minWidth: 150,
    hide: true,
    hideable: true,
    renderCell: (() => {
      if (DATE_FIELDS.has(key)) {
        return (params) => {
          if (!params.value) return "";
          // Use date-only format for start_date and end_date
          if (key === 'start_date' || key === 'end_date') {
            return formatUtcToLocalDateOnly(params.value);
          }
          return formatUtcToLocal(params.value);
        };
      }
      return;
    })(),
  }));

  return [...mainColumns, ...optionalCols];
};

export const savedTemplatesRowMapping = {
  choice: 'choice',
  template_name: 'template_name',
  created: 'created'
}
export const pdfRequestRowMapping = {
  request_timestamp: 'request_timestamp',
  campaign: 'campaign',
  current_contacts: 'current_contacts',
  custom_template_name: 'custom_template_name',
  request_status: 'request_status',
  conditional_url: 'conditional_url',
}
export const campaignRowMapping = {
  campaign_name: 'campaign_name',
  total: 'total',
}
export const respondedRowMapping = {
  greeting_name: 'greeting_name',
  'ma-addr_line1': 'ma-addr_line1',
}
export const contactVisitsRowMapping = {
  visited: 'visited',
  trackable: 'trackable',
  campaign: 'campaign',
}
export const existingUsersRowMapping = {
  customer_id: 'customer_id',
  name: 'name',
  user_name: 'user_name',
  email: 'email',
  phone: 'phone',
  tpx_id: 'tpx_id',
  created: 'created',
  user_id: 'user_id',
  cognito_pool_id: 'cognito_pool_id',
  role: 'role',
  account_status: 'account_status',
  confirmation_status: 'confirmation_status',
}

export const existingPlansRowMapping = {
  name: 'name',
  description: 'description',
  monthly_price: 'monthly_price',
  annual_price: 'annual_price',
  overage_price: 'overage_price',
  quota: 'quota',
  plan_id: 'plan_id',
  created: 'created',
  updated: 'updated',
}

export const existingSubscriptionsRowMapping = {
  subscription_id: 'subscription_id',
  user: 'user',
  plan: 'plan',
  status: 'status',
  customer_id: 'customer_id',
  subscription_plan_id: 'subscription_plan_id',
  start_date: 'start_date',
  end_date: 'end_date',
  billing_cycle: 'billing_cycle',
  payment_status: 'payment_status',
  created_timestamp: 'created_timestamp',
  updated_timestamp: 'updated_timestamp'
}

export const existingQuotaExtensionsRowMapping = {
  quota_extension_id: "quota_extension_id",
  price: "price",
  quota: "quota",
  used_quota: "used_quota",
  status: "status",
  created_timestamp: "created_timestamp"
}

export const existingActivitiesRowMapping = {
  created: 'created',
  action: 'action'
}

export const existingAdminActivitiesRowMapping = {
  timestamp: 'timestamp',
  actor: "actor",
  resource_type: "resource_type",
  action: 'action',
  resource_id: 'resource_id'
}
export const usageMetricsRowMapping = {
  usage_metric_id: "usage_metric_id",
  start_date: "start_date",
  end_date: "end_date",
  created_timestamp: "created_timestamp",
  quota: "quota",
  used_quota: "used_quota",
}


export const paymentsRowMapping = {
  date: "date",
  description: "description",
  amount: "amount"
}
export const generateGridRows = (data, mappingConfig, startIndex = 1) => {
  console.log('data', data)
  console.log('mappingConfig', mappingConfig)
  return data.map((record, index) => {
    const row = { id: startIndex + index }
    Object.keys(mappingConfig).forEach((key) => {
      const value = record[mappingConfig[key]]
      if (key === 'quota' && Array.isArray(value)) {
        row[key] = value.map(f => `${f.name}: ${f.quota}`).join('\n');
      } else {
        row[key] = Array.isArray(value) ? value.join(', ') : value;
      }
    })

    row._formData = record
    return row
  })
}

export const activityMapping = {
  action: 'Action',
  created: 'Created',
  'additional_data.campaign_name': 'Campaign',
  'additional_data.template_name': 'Template',
  'additional_data.contacts': 'Contacts',
  'additional_data.pdf_files': 'PDF Files',
}

export const quotaExtensionMapping = {
  quota_extension_id: "Quota Extensio ID",
  campaigns: "Campaigns",
  contacts: "Contacts",
  templates: "Templates",
  collaterals: "Collaterals",
  qrcodes: "QR Codes",
  trackables: "Trackables",
  requests: "Requests",
  status: "Status",
  price: "Price",
  created_timestamp: "Created"
}

export const usageMetricMapping = {
  usage_metric_id: "Metric ID",
  campaigns: "Campaigns",
  contacts: "Contacts",
  templates: "Templates",
  collaterals: "Collaterals",
  qrcodes: "QR Codes",
  trackables: "Trackables",
  requests: "Requests",
  start_date: "Start Date",
  end_date: "End Date",
  created_timestamp: "Created",
};


export const adminActivityMapping = {
  activity_log_id: 'Activity Log ID',
  actor: 'Actor',
  resource_type: "Resource Type",
  action: "Action",
  timestamp: "Timestamp",
  'details.id': 'ID',
  'details.description': 'Description',
}

export const paymentsMapping = {
  date: "Date",
  description: "Description",
  amount: "Amount"
}
export const campaignMapping = {
  campaign_name: 'Campaign',
  total: 'Contacts',
  created: 'Created',
  destination_url: 'Destination',
}



export const respondedMapping = {
  created: 'created',
  trackable_url: 'trackable_url',
  trackable: 'qrcode-id',
  envelope_name: 'envelope_name',
  greeting_name: 'greeting_name',
  'ma-addr_line1': 'ma-addr_line1',
  'ma-city': 'ma-city',
  'ma-state': 'ma-state',
  'ma-zip': 'ma-zip',
  visits: 'visits',
}

export const contactVisitsMapping = {
  visited: 'visited',
  trackable: 'qrcode-id',
  country: 'country',
  user_agent: 'user-agent',
  city: 'city',
  region: 'region',
}

export const generateFormData = (selectedRow, mappingConfig) => {
  if (!selectedRow) return [];

  return Object.keys(mappingConfig).map((key) => {
    // Check if this is a quota metric
    if (selectedRow.quota?.[key] !== undefined) {
      const used = selectedRow.used_quota?.[key] ?? 0;
      const total = selectedRow.quota?.[key] ?? 0;
      return {
        label: mappingConfig[key],
        value: `${used} / ${total}`,
      };
    }

    let value = selectedRow[key] ?? "";

    if ((key === 'created' || key === 'visited' || key === 'start_date' || key === 'end_date' || key === 'created_timestamp' || key === 'updated_timestamp' || key === 'timestamp') && typeof value === 'string') {
      // Use date-only format for start_date and end_date
      if (key === 'start_date' || key === 'end_date') {
        value = formatUtcToLocalDateOnly(value);
      } else {
        value = formatUtcToLocal(value);
      }
      console.log('value local time', value)
    }

    // Otherwise, show the raw value
    return {
      label: mappingConfig[key],
      value: value,
    };
  });
};

export function formatUtcToLocal(utcValue) {
  console.log('utcValue', utcValue)
  if (!utcValue || typeof utcValue !== 'string') return utcValue;

  // Ensure valid UTC ISO format
  const isoUtc = utcValue.includes('T')
    ? utcValue.endsWith('Z') ? utcValue : `${utcValue}Z`
    : utcValue.replace(' ', 'T') + 'Z';

  console.log('isoUtc', isoUtc)

  const date = new Date(isoUtc);
  if (isNaN(date.getTime())) return utcValue;

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log('timeZone', timeZone)
  let locale = 'en-US';
  if (timeZone === 'Asia/Kolkata' || timeZone === 'Asia/Calcutta') {
    locale = 'en-IN';
  } else if (timeZone.startsWith('Europe/')) {
    locale = 'en-GB';
  }
  // const locale = getLocaleFromTimeZone(timeZone);
  console.log('locale', locale)

  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  }).format(date);
}

// Format UTC date to local date only (without time)
export function formatUtcToLocalDateOnly(utcValue) {
  console.log('utcValue (date only)', utcValue)
  if (!utcValue || typeof utcValue !== 'string') return utcValue;

  // Ensure valid UTC ISO format
  const isoUtc = utcValue.includes('T')
    ? utcValue.endsWith('Z') ? utcValue : `${utcValue}Z`
    : utcValue.replace(' ', 'T') + 'Z';

  console.log('isoUtc (date only)', isoUtc)

  const date = new Date(isoUtc);
  if (isNaN(date.getTime())) return utcValue;

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log('timeZone (date only)', timeZone)
  let locale = 'en-US';
  if (timeZone === 'Asia/Kolkata' || timeZone === 'Asia/Calcutta') {
    locale = 'en-IN';
  } else if (timeZone.startsWith('Europe/')) {
    locale = 'en-GB';
  }
  console.log('locale (date only)', locale)

  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
}



// function getLocaleFromTimeZone(timeZone) {
//   if (!timeZone) return 'en-US';

//   // North America
//   if (timeZone.startsWith('America/')) return 'en-US';

//   // India
//   if (timeZone === 'Asia/Kolkata') return 'en-IN';

//   // Europe (example default)
//   if (timeZone.startsWith('Europe/')) return 'en-GB';

//   // Fallback
//   return 'en-US';
// }


const getCurrentMonthUsageMetric = (usageMetrics = []) => {
  const now = new Date();

  return usageMetrics.find(metric => {
    const start = new Date(metric.start_date);
    const end = new Date(metric.end_date);
    return now >= start && now < end;
  });
};

export const calculateUpgradeAmount = (
  currentSubscription,
  newPlanName,
  newBillingCycle,
  allPlans,
  usageMetrics
) => {
  if (!currentSubscription || !newPlanName || !newBillingCycle || !allPlans) {
    return null;
  }
  const currentPlan = allPlans.find(
    p => p.name === currentSubscription.plan
  );
  if (!currentPlan) return null;

  const annualPrice = Number(
    (currentPlan.annual_price || "0").toString().replace(/[^0-9.]/g, "")
  );
  console.log('annualPrice', annualPrice)
  const monthlyPrice = Number(
    (currentPlan.monthly_price || "0").toString().replace(/[^0-9.]/g, "")
  );
  console.log('monthlyPrice', monthlyPrice)

  const monthlyQuota = Number(
    currentPlan.quota?.collaterals || 0
  );
  console.log('monthlyQuota', monthlyQuota)

  const totalPaid =
    currentSubscription.billing_cycle === "Annual"
      ? annualPrice
      : monthlyPrice
  console.log('totalPaid', totalPaid)
  const effectiveMonthlyPrice =
    currentSubscription.billing_cycle === "Annual"
      ? annualPrice / 12
      : monthlyPrice;
  console.log('effectiveMonthlyPrice', effectiveMonthlyPrice)

  const pricePerCollateral =
    monthlyQuota > 0 ? effectiveMonthlyPrice / monthlyQuota : 0;
  console.log('pricePerCollateral', pricePerCollateral)


  const startDate = new Date(currentSubscription.start_date);
  console.log("Start date", startDate)
  const now = new Date();
  console.log("Now", now)

  let monthsElapsed =
    (now.getFullYear() - startDate.getFullYear()) * 12 +
    (now.getMonth() - startDate.getMonth());
  console.log("Months elapsed", monthsElapsed)

  if (now.getDate() < startDate.getDate()) {
    monthsElapsed--;
  }
  console.log("Months elapsed after date check", monthsElapsed)

  monthsElapsed = Math.max(0, monthsElapsed);
  console.log("Months elapsed after max check", monthsElapsed)

  const fullMonthsCost = monthsElapsed * effectiveMonthlyPrice;
  console.log("Full months cost", fullMonthsCost)

  // -----------------------------
  // 3. Current Month Usage Cost
  // -----------------------------
  const currentUsageMetric = getCurrentMonthUsageMetric(usageMetrics);

  console.log('currentUsageMetric', currentUsageMetric)

  const usedCollateralsThisMonth = Number(
    currentUsageMetric?.used_quota?.collaterals || 0
  );
  console.log('usedCollateralsThisMonth', usedCollateralsThisMonth)

  const currentMonthUsageCost =
    usedCollateralsThisMonth * pricePerCollateral;
  console.log('currentMonthUsageCost', currentMonthUsageCost)

  // -----------------------------
  // 4. Used Value & Credit
  // -----------------------------
  const usedValue = fullMonthsCost + currentMonthUsageCost;
  console.log('usedValue', usedValue)
  const remainingCredit = totalPaid - usedValue;
  console.log('remainingCredit', remainingCredit)

  // -----------------------------
  // 5. New Plan Cost
  // -----------------------------
  const newPlan = allPlans.find(p => p.name === newPlanName);
  console.log('newPlan', newPlan)
  if (!newPlan) return null;

  const newPlanMonthlyPrice = Number(
    (newPlan.monthly_price || "0").toString().replace(/[^0-9.]/g, "")
  );
  console.log('newPlanMonthlyPrice', newPlanMonthlyPrice)
  const newPlanAnnualPrice = Number(
    (newPlan.annual_price || "0").toString().replace(/[^0-9.]/g, "")
  );
  console.log('newPlanAnnualPrice', newPlanAnnualPrice)

  const newPlanCost =
    newBillingCycle === "Annual"
      ? newPlanAnnualPrice
      : newPlanMonthlyPrice;
  console.log('newPlanCost', newPlanCost)

  // -----------------------------
  // 6. Final Amount
  // -----------------------------
  let finalAmount = newPlanCost - remainingCredit;
  console.log('finalAmount', finalAmount)
  if (finalAmount < 0) finalAmount = 0;

  return {
    finalAmount: +finalAmount.toFixed(2),
    newPlanCost: +newPlanCost.toFixed(2),
    remainingCredit: +remainingCredit.toFixed(2),

    fullMonths: monthsElapsed,
    monthlyPrice: +effectiveMonthlyPrice.toFixed(2),
    fullMonthsCost: +fullMonthsCost.toFixed(2),
    usedCollateralsThisMonth,
    pricePerCollateral: +pricePerCollateral.toFixed(4),
    currentMonthUsageCost: +currentMonthUsageCost.toFixed(2),
    usedValue: +usedValue.toFixed(2),
  };
};

export function flattenObject(obj, parentKey = '', result = {}) {
  for (let key in obj) {

    if (!obj.hasOwnProperty(key)) continue;
    const propName = parentKey ? `${parentKey}.${key}` : key;
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      flattenObject(obj[key], propName, result);
    } else {
      result[propName] = obj[key];
    }
  }
  return result;
}
